import styled from "styled-components";

export const EditBlockWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
  margin-top: 35px;
  max-width: 1536px;
  width: 100%;
`;
